import { Link } from "react-router-dom";
import { withUtm } from "@/lib/utm";
import {
  ArrowLeft, Search, MapPin, Sparkles, PlayCircle, CheckCircle2,
} from "lucide-react";

export default function HeroSection({ oppCount, searchTerm, setSearchTerm, submitSearch }) {
  return (
    <section className="relative min-h-[86vh] flex items-center overflow-hidden" data-testid="hero-section">
      <img
        src="https://customer-assets-39nsmqrw.emergentagent.net/job_talent-hub-822/artifacts/h8usknbo_%D8%B9%D9%85%D8%A7%D8%AF%20%D8%B1%D8%AD%D9%84%D8%A9%20%D8%A7%D9%84%D8%A7%D8%AB%D8%B1%20%D8%A7%D9%84%D9%85%D8%B3%D8%AA%D8%AF%D8%A7%D9%85.jpeg"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-slate-950/85 via-slate-950/70 to-teal-950/95" />
      <div className="absolute inset-0 bg-gradient-to-tl from-rose-900/25 via-transparent to-amber-800/15 mix-blend-overlay" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 py-14 sm:py-20 lg:py-24 z-10 w-full">
        <div className="grid lg:grid-cols-12 gap-8 lg:gap-10 items-center">
          <div className="lg:col-span-8">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-md text-white/90 text-xs font-bold border border-white/20 fade-in-up">
              <Sparkles className="h-3.5 w-3.5 text-amber-300" />
              عماد — رحلة الأثر المستدام
            </div>

            <h1
              className="mt-6 text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black font-heading leading-[1.15] text-white fade-in-up"
              style={{ animationDelay: "0.15s" }}
            >
              من هنا تبدأ
              <br />
              <span className="block mt-2 text-2xl lg:text-4xl xl:text-5xl text-amber-300">رحلة الأثر المجتمعي</span>
            </h1>

            <p
              className="mt-6 text-base lg:text-lg xl:text-xl text-teal-50/95 leading-relaxed max-w-2xl fade-in-up"
              style={{ animationDelay: "0.3s" }}
            >
              تعلّم، مارس داخل منظمة، وتابع أثر عملك حتى شهادة الإنجاز.
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-3 fade-in-up" style={{ animationDelay: "0.45s" }}>
              <Link
                to={withUtm("/opportunities")}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-teal-900 font-bold hover:bg-amber-50 hover:-translate-y-0.5 focus-visible:ring-4 focus-visible:ring-white/30 transition-all text-sm lg:text-base"
                data-testid="hero-cta-opps"
              >
                استعرض الفرص <ArrowLeft className="h-4 w-4 lg:h-5 lg:w-5" />
              </Link>
              <a
                href="#journey"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-transparent border border-white/30 text-white font-semibold hover:bg-white/10 focus-visible:ring-4 focus-visible:ring-white/20 transition-all text-sm lg:text-base"
                data-testid="hero-cta-journey"
              >
                <PlayCircle className="h-4 w-4 lg:h-5 lg:w-5" /> تعرّف على الرحلة
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 fade-in-up" style={{ animationDelay: "0.55s" }}>
            <form
              onSubmit={submitSearch}
              className="p-4 rounded-2xl bg-white/8 backdrop-blur-md border border-white/15"
              data-testid="hero-search"
            >
              <div className="text-xs text-white/70 mb-3 flex items-center gap-1.5">
                <Search className="h-3.5 w-3.5" /> ابحث عن فرصة التدريب التعاوني المناسبة
              </div>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="ابحث بالتخصص أو المدينة..."
                className="w-full rounded-xl bg-white/95 text-slate-900 placeholder:text-slate-500 px-4 py-3 text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-300/60"
                data-testid="hero-search-input"
                aria-label="ابحث عن فرصة التدريب التعاوني"
                onKeyDown={(e) => { if (e.key === "Enter") submitSearch(e); }}
              />
              <div className="mt-3 flex items-center gap-4 text-xs text-white/80">
                <span className="inline-flex items-center gap-1">
                  <CheckCircle2 className="h-3.5 w-3.5 text-amber-300" />
                  <span className="arabic-numerals">{oppCount ?? "—"}</span> فرصة الآن
                </span>
                <span className="inline-flex items-center gap-1">
                  <MapPin className="h-3.5 w-3.5 text-amber-300" /> +10 مدن
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
